import ApisService from './index'
import {
  IOrderCurrencyAdd,
} from '../interfaces/orderInterfaces'
import { IBillOfLadingCodeImport } from '../interfaces/billOfLadingCodeImportInterfaces'

import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'


export function createOrderCurrency(data: IOrderCurrencyAdd) {
  try {
    return ApisService.post('/donmua/create-donmua-tiente', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

// cập nhật báo giá
export function updateOrderCurrency(data: IOrderCurrencyAdd) {
  try {
    return ApisService.put('/donmua/' + data.id + '/update-donmua-tiente', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

// gét chi tiết báo giá, đơn mua
export function getDetailOrder(id: string) {
  try {
    return ApisService.get('/donmua/' + id + '/get-chitiet-donmua')
  } catch (err) {
    handleError(err)
    throw err
  }
}
// gét chi tiết báo giá, đơn mua tiền tệ
export function getDetailOrderCurrency(id: string) {
  try {
    return ApisService.get('/donmua/' + id + '/get-chitiet-donmua-tiente')
  } catch (err) {
    handleError(err)
    throw err
  }
}


// Lấy danh sách hàng về thực tế
export function getListOrderPurchasesReality(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/filter-donmua-yeucaumua-thucte', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListOrderPurchases(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/filter-donmua-yeucaumua', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}


// Lấy danh sách báo giá, đơn mua
export function getListOrderCurrency(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/filter-donmua-tiente', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}


// Lấy danh sách báo giá, đơn mua
export function getListOrder(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/filter-donmua', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteOrder(id: string) {
  try {
    return ApisService.delete('/donmua/' + id + '/delete-donmua')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteMultiOrder(idArr: Array<string>) {
  try {
    return ApisService.delete('/donmua/bulk-delete-donmua', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách yêu cầu mua cần báo giá
export function getListRequest(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/filter-yeucaumua', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// chốt báo giá
export function updateOrderConfirm(id: string) {
  try {
    return ApisService.put('/donmua/' + id + '/chotbaogia')
  } catch (err) {
    handleError(err)
    throw err
  }
}


// cập hật tình trạng đơn hàng
export function updateOrderAttach(thongTinThems: Array<any>) {
  try {
    return ApisService.put('/donmua/update-donmua-thongtinthem', { thongTinThems: thongTinThems })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// Thêm hàng về thực tế
export function createOrderReality(data: any) {
  try {
    return ApisService.post('/donmua/add-hangve-thuctes', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

// xóa hàng về thực tế
export function deleteOrderReality(id: string | number) {
  try {
    return ApisService.delete('/donmua/' + id + '/delete-hangve-thucte')
  } catch (err) {
    handleError(err)
    throw err
  }
}


// khóa
export function lockOrderReality(ids: Array<any>) {
  try {
    return ApisService.post('/donmua/lock-donmua-yeucaumua', ids)
  } catch (err) {
    handleError(err)
    throw err
  }
}

// mở khóa
export function unLockOrderReality(ids: Array<any>) {
  try {
    return ApisService.post('/donmua/unlock-donmua-yeucaumua', ids)
  } catch (err) {
    handleError(err)
    throw err
  }
}



export function getHistoryOrderLatest(payload: any) {
  try {
    return ApisService.get('/donmua/get-donmua-gan-nhat', {
      params: payload
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListHistoryOrder(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/baocao-tonghop', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// import mã vận đơn
export function importbillOfLadingCode(data: Array<IBillOfLadingCodeImport>) {
  try {
    return ApisService.post('/donmua/import-tracuu', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deleteBillOfLadingCode(idArr: string[]) {
  try {
    return ApisService.delete('/donmua/delete-tracuu', { data: idArr })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách báo giá, đơn mua
export function getListBillOfLadingCode(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/donmua/filter-tracuu', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// tính giá vốn
export function getCapitalPriceOrder(data: IOrderCurrencyAdd) {
  // const bodyData = {...data}
  const donMuaYeuCauMuas = data.donMuaYeuCauMuas.map((item1) => {
    const donMuaYeuCauMuaHinhThucVanChuyens = item1.donMuaYeuCauMuaHinhThucVanChuyens.map(item2 => {
      return {
        hinhThucVanChuyenId: item2?.hinhThucVanChuyen?.id,
        tienVanChuyenNoiDia: item2?.tienVanChuyenNoiDia || 0,
        tyGiaVanChuyenNoiDia: item2?.tyGiaVanChuyenNoiDia || 0,
        isShow: item2?.isShow,
      }
    })
    return {
      ...item1,
      donMuaYeuCauMuaHinhThucVanChuyens: donMuaYeuCauMuaHinhThucVanChuyens
    }
  })
  try {
    return ApisService.post('/donmua/' + data.id + '/tinhgiavon-donmua', { ...data, donMuaYeuCauMuas: donMuaYeuCauMuas })
  } catch (err) {
    handleError(err)
    throw err
  }
}

// tính giá vốn
export function getCapitalPriceOrderContainer(data: IOrderCurrencyAdd) {
  // const bodyData = {...data}
  const donMuaYeuCauMuas = data.donMuaYeuCauMuas.map((item1) => {
    const donMuaYeuCauMuaHinhThucVanChuyens = item1.donMuaYeuCauMuaHinhThucVanChuyens.map(item2 => {
      return {
        hinhThucVanChuyenId: item2?.hinhThucVanChuyen?.id,
        tienVanChuyenNoiDia: item2?.tienVanChuyenNoiDia || 0,
        tyGiaVanChuyenNoiDia: item2?.tyGiaVanChuyenNoiDia || 0,
        isShow: item2?.isShow,
      }
    })
    return {
      ...item1,
      donMuaYeuCauMuaHinhThucVanChuyens: donMuaYeuCauMuaHinhThucVanChuyens
    }
  })
  try {
    return ApisService.post('/donmua/' + data.id + '/tinhgiavon-donmua', { ...data, donMuaYeuCauMuas: donMuaYeuCauMuas })
  } catch (err) {
    handleError(err)
    throw err
  }
}
